/* ---------- İş Emri ---------- */
export const IS_EMRI_DURUMLARI = ['Bekliyor', 'Devam', 'Tamamlandi', 'Teslim', 'Iptal'];
export const IS_EMRI_DURUM_ADI = {
    Bekliyor: 'Bekliyor',
    Devam: 'Devam ediyor',
    Tamamlandi: 'Tamamlandı',
    Teslim: 'Teslim edildi',
    Iptal: 'İptal',
};
export const ODEME_DURUMLARI = ['Odenmedi', 'Kismi', 'Odendi'];
export const ODEME_DURUM_ADI = {
    Odenmedi: 'Ödenmedi',
    Kismi: 'Kısmi ödeme',
    Odendi: 'Ödendi',
};
export const KALEM_TURLERI = ['hizmet', 'urun'];
/* ---------- Dosyalar ---------- */
export const DOSYA_TURLERI = ['log', 'ecu', 'foto', 'diger'];
export const DOSYA_TUR_ADI = {
    log: 'Log',
    ecu: 'ECU / TCU dosyası',
    foto: 'Fotoğraf',
    diger: 'Diğer',
};
/* ---------- Kasa ---------- */
export const HAREKET_TURLERI = ['Girdi', 'Cikti'];
export const ODEME_TIPLERI = ['Nakit', 'Havale', 'Kart', 'Diger'];
/**
 * Arayüzde gösterilen adlar. Veritabanında kısa kod durur (Havale, Diger);
 * ekranda eski Nero Kasa'daki gibi tam Türkçe karşılığı görünür.
 */
export const ODEME_TIPI_ADI = {
    Nakit: 'Nakit',
    Havale: 'Havale/EFT',
    Kart: 'Kart',
    Diger: 'Diğer',
};
/** Stok hareketinin sebebi — raporda ve listede Türkçe gösterilir. */
export const STOK_SEBEP_ADI = {
    acilis: 'Açılış stoğu',
    ekle: 'Stok ekleme',
    cikar: 'Stok çıkarma',
    duzeltme: 'Sayım düzeltmesi',
    manuel: 'Elle düzeltme',
    satis: 'Satış',
    iade: 'İade',
    is_emri: 'İş emri kullanımı',
};
/* ---------- Cari ---------- */
export const CARI_ISLEM_TURLERI = ['alacak_ekle', 'borc_ekle', 'tahsilat', 'odeme'];
/** Eski Nero Kasa'daki adlarıyla gösterilir; anlam kaybolmaz. */
export const CARI_ISLEM_ADI = {
    alacak_ekle: 'Alacak Ekle',
    borc_ekle: 'Borç Ekle',
    tahsilat: 'Tahsilat',
    odeme: 'Ödeme',
};
/** Kullanıcıya ne anlama geldiğini anlatan kısa açıklama. */
export const CARI_ISLEM_ACIKLAMA = {
    alacak_ekle: 'Müşteri bize borçlanır (bakiye artar)',
    borc_ekle: 'Biz müşteriye borçlanırız (bakiye azalır)',
    tahsilat: 'Müşteriden para aldık (bakiye azalır)',
    odeme: 'Müşteriye para ödedik (bakiye artar)',
};
export const CARI_KAYNAK_ADI = {
    manuel: 'Elle girildi',
    acilis: 'Başlangıç bakiyesi',
    ice_aktarim: 'Eski veriden aktarıldı',
    sistem: 'Sistem oluşturdu',
};
//# sourceMappingURL=tipler.js.map